export default "__VITE_ASSET__6f1cc51e__"